import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Dashboard from "../Dashboard";
import Chicken from "../../../img/Chicken.png";
import ChillyPowder from "../../../img/ChillyPowder.png";
import FreshSpinach from "../../../img/FreshSpinach.png";
import ZoneSheets from "../../../img/ZoneSheets.svg";
import LabelSheets from "../../../img/LabelSheets.svg";
import GrocerySheets from "../../../img/GrocerySheets.svg";
import Header from "../Header/Header";
import { toast } from "react-toastify";
import {
  getIngredientslist,
  api_url,
  Inventory_list,
} from "../../../Redux/Reducer/AuthReducer";
import { useDispatch } from "react-redux";
import DateRangePicker from "react-bootstrap-daterangepicker";
import calender from "../../../img/Icon/calender.svg";
import CsvDownloader from "react-csv-downloader";
import { CSVLink } from "react-csv";
import Modal from "react-modal";
import fmblogo from "../../../img/fmb-logo.png";
import moment from "moment";
import loadergif from "../../../img/landing/loader123.gif";
import warningLogo from "../../../img/Icon/warning-round.svg"

export default function ExportInventoryCombined() {
  const user_Role = localStorage.getItem("access_Role");
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };
  var token = localStorage.getItem("access_token");
  const dispatch = useDispatch();
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const viewIndata = location.state?.viewInventorydata || [];
  const selectdatelist = location.state?.selectdate || [];
  const selectMiqaatdatelist = location.state?.selectMiqaatdate || [];

  const rangeEndDate = location.state?.rangeEndDate || [];
  const rangeStartDate = location.state?.rangeStartDate || [];
  const currentRangeEndDate = location.state?.currentRangeEndDate || [];

  const weekStartDate = location.state?.weekStartDate || [];
  const weekEndDate = location.state?.weekEndDate || [];
  const totalselectedFullThaaliCount = location.state?.totalselectedFullThaaliCount || [];
  const totalselectedMiqaatThaalCount = location.state?.totalselectedMiqaatThaalCount || [];


  const [Ingredientslist, setIngredientsList] = useState(viewIndata);
  const [IngredientsDate, setIngredientsDate] = useState("");
  const [IngredientsThalicount, setIngredientsThalicount] = useState("");
  const [totalInventory, settotalInventory] = useState("");
  const scheduleDays = Ingredientslist?.schedule?.map(
    (item) => item?.schedule_day
  );
  const IngredientDays = Ingredientslist?.schedule.map(
    (item) => item?.ingredient_schedule_day
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [RemoveIsOpen, setIsRemoveOpen] = React.useState(false);
  const [standardinventory, setStandardInventory] = useState("1");
  const [skipRemainingDays, setSkipRemainingDays] = useState("1");

  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState("ingredient_name");
  const [allenddate, setAllEndDate] = useState(rangeStartDate);
  const [allstartdate, setAllStartDate] = useState(rangeEndDate);
  const [createInventoryCalled, setCreateInventoryCalled] = useState(false);
  const access_id = localStorage.getItem("access_id");
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  
  
  // Helper function to check if the date is older than 6 months
  const isOlderThanSixMonths = (dateString) => {
    if (!dateString) return false;
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 3);
    return new Date(dateString) < sixMonthsAgo;
  };


  useEffect(() => {
    // Check if Ingredientslist has a length of 0, and set loading accordingly
    if (Ingredientslist.length === 0) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [Ingredientslist]);

  function RemoveOpenModal() {
  }
  function RemoveModal() {
    getInventoryList()
  }

  function RemovecloseModal() {
    setIsRemoveOpen(false);
  }

  //Check if any Pending Inventory
  const getInventoryList = () => {
    setLoading(true);
    let reuestURL = Inventory_list + "admin/inventory-list"
    fetch(reuestURL, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json", // Assuming you're sending form data
        Authorization: localStorage.getItem("access_token"),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.status == true) {
          setLoading(false);
          var item = data?.data.find(item=>item.status=="Pending");
          if(item) { 
            setIsRemoveOpen(true);
          }else {
            Createinventory()
          }
        } else {
          console.log("error ", data);
        }
      })
      .catch((error) => {
        console.error(error);
      })
  };


  const [selectedOption, setSelectedOption] = useState(false);

  const handleToggleChange2 = (e) => {
    const newValue = standardinventory === "1" ? "" : "1";
    setStandardInventory(newValue);

    const requestBody = {
      standard: newValue,
      schedule_id: selectdatelist,
      schedule_miqaat_id: selectMiqaatdatelist,
      by_day: selectedOption,
      end_date: rangeEndDate,
      start_date: rangeStartDate,
      curr_end_date: currentRangeEndDate,
      skip_remaining_days: skipRemainingDays,
    };
    getselectdatachange(requestBody);
  };


  const handleToggleSkipRemainingDays = (e) => {
    const newValue = skipRemainingDays === "1" ? "" : "1";
    setSkipRemainingDays(newValue);

    const requestBody = {
      standard: standardinventory,
      skip_remaining_days: newValue,
      schedule_id: selectdatelist,
      schedule_miqaat_id: selectMiqaatdatelist,
      by_day: selectedOption,
      end_date: rangeEndDate,
      start_date: rangeStartDate,
      curr_end_date: currentRangeEndDate,
    };
    getselectdatachange(requestBody);
  };


  const getselectdatachange = (requestBody) => {
    setLoading(true);
    let reuestURL =
      requestBody.by_day == "true"
        ? Inventory_list + "admin/inventory-combined-day-aggregate"
        : Inventory_list + "admin/inventory-combined-aggregate";

    fetch(reuestURL, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json", // Assuming you're sending form data
        Authorization: localStorage.getItem("access_token"),
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.status == true) {
          setSelectedOption(requestBody.by_day);
          setIngredientsList(data?.data);
          settotalInventory(data?.data.ingredientCount);
          setLoading(false); // Set loading to false when data fetching is complete
          if(requestBody.by_day == "false" && requestBody.standard == '1'){
            window.location.reload()
          }
        } else {
          console.log("error ", data);
        }
      })
      .catch((error) => {
        setLoading(false); // Set loading to false when data fetching is complete
        console.error(error);
      })
      .finally(() => {
        setLoading(false); // Set loading to false when data fetching is complete
      });
  };
  const handleButtonChange = (value) => {
    value == true ? setStandardInventory("0") : setStandardInventory("1");

    setSkipRemainingDays("1");
    const requestBody = {
      standard: (value == "true" || value == true) ? 0 : 1,
      schedule_id: selectdatelist,
      schedule_miqaat_id: selectMiqaatdatelist,
      by_day: value,
      end_date: rangeEndDate,
      start_date: rangeStartDate,
      curr_end_date: currentRangeEndDate,
      skip_remaining_days: skipRemainingDays
    };
    if (value == "true" || value == true) 
       setStandardInventory("0")

    getselectdatachange(requestBody);
  };


  useEffect(() => {
    setIngredientsDate(
      Ingredientslist.schedule_day ? Ingredientslist.schedule_day : "-"
    );
    setIngredientsThalicount(Ingredientslist.thaaliCount);
    settotalInventory(Ingredientslist.ingredientCount);
  }, []);

  var dateName = function (yyyy, mm, dd, full) {
    var monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var dayNames = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];
    var today = new Date(yyyy, mm - 1, dd);
    var dd = today.getDate();
    var dayNameIndex = (today.getDay() - 1) == -1 ? 6 : today.getDay() - 1
    var dayname = dayNames[dayNameIndex];
    var mm1 = monthNames[today.getMonth()];
    var yyyy1 = today.getFullYear();
    var fullDate = full === "true" ? mm + "/" + dd + "/" + yyyy :mm1 + " " + dd;
    return fullDate;
  };

  const formatDate = (dateString, full) => {
    if (!dateString) {
      return ""; // return empty string if dateString is undefined or empty
    }
    const formattedCurrentDate = dateString && dateString?.split("T")[0]; // Convert date to ISO string
    const dayInformation = dateName(formattedCurrentDate?.split("-")[0], formattedCurrentDate?.split("-")[1], formattedCurrentDate?.split("-")[2], full)
    return dayInformation;
  };

  const Statedate = scheduleDays[0];
  const IngredientStatedate = IngredientDays[0];
  const Enddate = scheduleDays[scheduleDays.length - 1];
  const IngredientEnddate = IngredientDays[IngredientDays.length - 1];

  const StatedateToStore = Statedate;
  localStorage.setItem("Statedate", StatedateToStore);

  const EnddateToStore = Enddate;
  localStorage.setItem("Enddate", EnddateToStore);

//

// csv file download

const csvNoCostData = Ingredientslist?.schedule.map((items) => {
  return {
    // Date: formattedDate || "-",
    IngredientName: items?.ingredient_name,
    PackageUnit: items?.package_unit,
    PackageType: items?.package_type !== "NULL" ? items.package_type : "-",
    PackageSize: items?.package_size !== "NULL" ? items.package_size : "-",
    VendorName: items?.vendor_name1,
    Quantity: items.total_quantity?.toFixed(2),
    Quantity100: items.menu_quantity,
    Notes: items?.ingredient_note !== "NULL" ? items.ingredient_note : "-",
  };
});

const csvNoCostHeaders = [
  { label: "Ingredient Name", key: "IngredientName" },
  { label: "Quantity", key: "Quantity" },
  { label: "Quantity (100 Thaalis/10 Thaals)", key: "Quantity100" },
  { label: "Package Unit", key: "PackageUnit" },
  { label: "Vendor Name", key: "VendorName" },
  { label: "Package Size", key: "PackageSize" },
  { label: "Notes", key: "Notes" },
];

const csvNoCostDataDay = Ingredientslist?.schedule.reduce((accumulator, items) => {
  const formattedDate = formatDate(items?.schedule_day, "true")
  const menuItems = (items?.menu && items?.menu !== "NA") ? JSON.parse(items?.menu) : "";
  const rows = Array.isArray(menuItems)
    ? menuItems.map((menuItem) => ({
        Date: formattedDate || "-",
        ScheduleType: items?.schedule_type,
        IngredientName: items?.ingredient_name,
        PackageUnit: items?.package_unit,
        Menu: items?.dish_name,
        PackageType:
          items?.package_type !== "NULL" ? items.package_type : "-",
        PackageSize:
          items?.package_size !== "NULL" ? items.package_size : "-",
        VendorName: items?.vendor_name1,
        Quantity: items.total_quantity?.toFixed(2),
        Quantity100: items.menu_quantity,
        Notes: items?.ingredient_note !== "NULL" ? items.ingredient_note : "-",
      }))
    : [
        {
          Date: formattedDate || "-",
          ScheduleType: items?.schedule_type,
          IngredientName: items?.ingredient_name,
          PackageUnit: items?.package_unit,
          Menu: items?.dish_name,
          PackageType:
          items?.package_type !== "NULL" ? items.package_type : "-",
          PackageSize:
          items?.package_size !== "NULL" ? items.package_size : "-",
          PackageSize: items?.package_size,
          VendorName: items?.vendor_name1,
          Quantity: items.total_quantity?.toFixed(2),
          Quantity100: items.menu_quantity,
          Notes: items?.ingredient_note !== "NULL" ? items.ingredient_note : "-",
        },
      ];

  // Filter out duplicates based on the combination of Date, IngredientName, and Menu
  const uniqueRows = rows.filter(
    (row, index, self) =>
      index ===
      self.findIndex(
        (r) =>
          r.Date === row.Date &&
          r.IngredientName === row.IngredientName &&
          r.Menu === row.Menu
      )
  );

  return [...accumulator, ...uniqueRows];
}, []);

const csvNoCostHeadersDay = [
  { label: "Date", key: "Date" },
  { label: "Schedule Type", key: "ScheduleType" },
  { label: "Menu", key: "Menu" },
  { label: "Ingredient Name", key: "IngredientName" },
  { label: "Quantity", key: "Quantity" },
  { label: "Quantity (100 Thaalis/10 Thaals)", key: "Quantity100" },
  { label: "Package Unit", key: "PackageUnit" },
  { label: "Vendor Name", key: "VendorName" },
  { label: "Package Size", key: "PackageSize" },
  { label: "Notes", key: "Notes" },
];

//



  // csv file download

  const csvData = Ingredientslist?.schedule.map((items) => {
    return {
      // Date: formattedDate || "-",
      IngredientName: items?.ingredient_name,
      PackageUnit: items?.package_unit,
      PackageType: items?.package_type !== "NULL" ? items.package_type : "-",
      PackageSize: items?.package_size !== "NULL" ? items.package_size : "-",
      VendorName: items?.vendor_name1,
      Quantity: items.total_quantity?.toFixed(2),
      Quantity100: items.menu_quantity,
      IngredientCost: items.ingredient_cost ? "$ "+items.ingredient_cost?.toFixed(2) : "$ 0.00",
      Notes: items?.ingredient_note !== "NULL" ? items.ingredient_note : "-",
    };
  });

  const csvHeaders = [
    { label: "Ingredient Name", key: "IngredientName" },
    { label: "Quantity", key: "Quantity" },
    { label: "Quantity (100 Thaalis/10 Thaals)", key: "Quantity100" },
    { label: "Package Unit", key: "PackageUnit" },
    { label: "Vendor Name", key: "VendorName" },
    { label: "Package Size", key: "PackageSize" },
    { label: "Ingredient Cost", key: "IngredientCost" },
    { label: "Notes", key: "Notes" },
  ];

  const csvDataDay = Ingredientslist?.schedule.reduce((accumulator, items) => {
    const formattedDate = formatDate(items?.schedule_day, "true")
    const menuItems = (items?.menu && items?.menu !== "NA") ? JSON.parse(items?.menu) : "";
    const rows = Array.isArray(menuItems)
      ? menuItems.map((menuItem) => ({
          Date: formattedDate || "-",
          ScheduleType: items?.schedule_type,
          IngredientName: items?.ingredient_name,
          PackageUnit: items?.package_unit,
          Menu: items?.dish_name,
          PackageType:
            items?.package_type !== "NULL" ? items.package_type : "-",
          PackageSize:
            items?.package_size !== "NULL" ? items.package_size : "-",
          VendorName: items?.vendor_name1,
          Quantity: items.total_quantity?.toFixed(2),
          Quantity100: items.menu_quantity,
          IngredientCost: items.ingredient_cost ? "$ "+items.ingredient_cost?.toFixed(2) : "$ 0.00",
          Notes: items?.ingredient_note !== "NULL" ? items.ingredient_note : "-",
        }))
      : [
          {
            Date: formattedDate || "-",
            ScheduleType: items?.schedule_type,
            IngredientName: items?.ingredient_name,
            PackageUnit: items?.package_unit,
            Menu: items?.dish_name,
            PackageType:
            items?.package_type !== "NULL" ? items.package_type : "-",
            PackageSize:
            items?.package_size !== "NULL" ? items.package_size : "-",
            PackageSize: items?.package_size,
            VendorName: items?.vendor_name1,
            Quantity: items.total_quantity?.toFixed(2),
            Quantity100: items.menu_quantity,
            IngredientCost: items.ingredient_cost ? "$ "+items.ingredient_cost?.toFixed(2) : "$ 0.00",
            Notes: items?.ingredient_note !== "NULL" ? items.ingredient_note : "-",
          },
        ];

    // Filter out duplicates based on the combination of Date, IngredientName, and Menu
    const uniqueRows = rows.filter(
      (row, index, self) =>
        index ===
        self.findIndex(
          (r) =>
            r.Date === row.Date &&
            r.IngredientName === row.IngredientName &&
            r.Menu === row.Menu
        )
    );

    return [...accumulator, ...uniqueRows];
  }, []);

  const csvHeadersDay = [
    { label: "Date", key: "Date" },
    { label: "Schedule Type", key: "ScheduleType" },
    { label: "Menu", key: "Menu" },
    { label: "Ingredient Name", key: "IngredientName" },
    { label: "Quantity", key: "Quantity" },
    { label: "Quantity (100 Thaalis/10 Thaals)", key: "Quantity100" },
    { label: "Package Unit", key: "PackageUnit" },
    { label: "Vendor Name", key: "VendorName" },
    { label: "Package Size", key: "PackageSize" },
    { label: "Ingredient Cost", key: "IngredientCost" },
    { label: "Notes", key: "Notes" },
  ];

  // pagination
  const itemsPerPage = Ingredientslist?.schedule?.length; // Set the number of items to display per page
  const totalItems = Ingredientslist?.schedule?.length || 0;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Function to handle page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getCurrentPageItems = () => {
    return Ingredientslist?.schedule;
  };

  const Createinventory = () => {
    setIsRemoveOpen(false);

    if(createInventoryCalled == true) {
      return;
    }

    setCreateInventoryCalled (true)
    setLoading(true);
    setIsRemoveOpen(false);
    const allIngredients = Ingredientslist?.schedule.map((item) => item.id);
    const menuQuantity = Ingredientslist?.schedule.map(
      (item) => item.total_quantity
    );
    const IngredientDays = Ingredientslist?.schedule.map(
      (item) => item.ingredient_schedule_day
    );

    const ingredients = allIngredients.map((ingredient_id, index) => ({
      menu_quantity: menuQuantity[index]?.toFixed(2),
      ingredient_id: ingredient_id,
    }));
    const requestBody = {
      start_date: rangeStartDate,
      end_date: rangeEndDate,
      status: "Pending",
      created_user: access_id,
      ingredients: ingredients,
    };

    console.log("requestBody", requestBody);
    fetch(Inventory_list + "admin/inventory-insert", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json", // Assuming you're sending form data
        Authorization: localStorage.getItem("access_token"),
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.status === true) {
          // const viewInventory = data.data;
          // Pass the thalicountData to the ThaliPage route using navigate
          // navigate('/InventoryFMB', { state: { viewInventorydata: viewInventory, selectdate: selectedCheckbox } });
          setTimeout(() => {
            setLoading(false);
            setIsRemoveOpen(false);
            toast.success(data?.message);
            setCreateInventoryCalled (false)
          }, 2000);
        } else {
          // toast.error("Select Date");
          setLoading(false);
          console.log("error ", data);
        }
      })
      .catch((error) => {
        setLoading(false); // Set loading to false when data fetching is complete
        console.error(error);
      })
      // .finally(() => {
      //   setLoading(false); // Set loading to false when data fetching is complete
      // });
  };
  useEffect(() => {
    // This code will run when the component is first rendered.
    // Set the default selected option here if needed.
    setSelectedOption("false");

    // Additional initialization logic can go here if necessary.
  }, []);

  // Ingredient Sort
  const handleSort = (column) => {
    if (column === sortColumn) {
      setSortOrder((prevSortOrder) =>
        prevSortOrder === "asc" ? "desc" : "asc"
      );
    } else {
      setSortColumn(column);
      setSortOrder("asc");
    }
  };

  const getSortIcon = (columnName) => {
    if (sortColumn === columnName) {
      return sortOrder === "asc" ? (
        <i className="fa fa-sort-up"></i>
      ) : (
        <i className="fa fa-sort-down"></i>
      );
    }
    return null;
  };

  return (
    <div>
      <Header />
      <div className="main_section exp_in">
        <div className="ExportInventory thali_section">
          <div className="container-fluid">
            <div className="thili_div">
              <div className="Back-page">
                {" "}
                <Link to="/Procurement-Combined">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M7.175 15.4748L0.225 8.5248C0.141667 8.44147 0.0833335 8.35814 0.0500002 8.2748C0.0166669 8.19147 0 8.0998 0 7.9998C0 7.8998 0.0166669 7.80814 0.0500002 7.7248C0.0833335 7.64147 0.141667 7.55814 0.225 7.4748L7.2 0.499804C7.33333 0.366471 7.5 0.299805 7.7 0.299805C7.9 0.299805 8.075 0.374805 8.225 0.524805C8.375 0.674805 8.45 0.849805 8.45 1.0498C8.45 1.2498 8.375 1.4248 8.225 1.5748L2.55 7.2498H14.95C15.1667 7.2498 15.3458 7.32064 15.4875 7.4623C15.6292 7.60397 15.7 7.78314 15.7 7.9998C15.7 8.21647 15.6292 8.39564 15.4875 8.5373C15.3458 8.67897 15.1667 8.7498 14.95 8.7498H2.55L8.25 14.4498C8.38333 14.5831 8.45 14.7498 8.45 14.9498C8.45 15.1498 8.375 15.3248 8.225 15.4748C8.075 15.6248 7.9 15.6998 7.7 15.6998C7.5 15.6998 7.325 15.6248 7.175 15.4748Z"
                      fill="#777391"
                    />
                  </svg>
                </Link>
                <h1 className="title_heading">
                  &nbsp; &nbsp; &nbsp; View Combined Ingredients
                </h1>
              </div>

              <div className="New_section">
                {/* <div className='Form_box'>
                  <div className='Calender_div'>
                    <img src={calender} className='img-fluid' /> &nbsp; &nbsp;
                    <DateRangePicker
                      initialSettings={{ startDate: '12/04/2023', endDate: '01/15/2032' }}
                    >
                      <input type="text" className="form-control" />
                    </DateRangePicker>
                  </div>
                </div> */}
                {/* <span className='Line_div'></span> */}
                {/* <button className="btn thali_btn">Refresh</button> */}
                {/* { selectedOption == "false" &&
                <div className="Thali_page_btn AddStandardInventory">
                  <label for="Standard" className="form-label">
                    Skip Remaining Days &nbsp; &nbsp;
                  </label>
                  <div className="onoffswitch">
                    <input
                      type="checkbox"
                      name="onoffswitchSkip"
                      className="onoffswitch-checkbox"
                      id="rice_check_skip"
                      checked={skipRemainingDays == "1"}
                      onChange={handleToggleSkipRemainingDays}
                    />
                    <label className="onoffswitch-label" for="rice_check_skip">
                      <span className="onoffswitch-inner"></span>
                      <span className="onoffswitch-switch"></span>
                    </label>
                  </div>
                  &nbsp; &nbsp; &nbsp; &nbsp;
                </div>
                } */}
                <div className="Thali_page_btn AddStandardInventory">
                  <label for="Standard" className="form-label">
                    Add Standard Ingredients &nbsp; &nbsp;
                  </label>
                  <div className="onoffswitch">
                    <input
                      type="checkbox"
                      name="onoffswitch"
                      className="onoffswitch-checkbox"
                      id="rice_check"
                      checked={standardinventory == "1"}
                      onChange={handleToggleChange2}
                    />
                    <label className="onoffswitch-label" for="rice_check">
                      <span className="onoffswitch-inner"></span>
                      <span className="onoffswitch-switch"></span>
                    </label>
                  </div>
                  &nbsp; &nbsp; &nbsp; &nbsp;
                  {/* <button onClick={RemoveModal}>sss</button> */}
                </div>
                { ((user_Role.includes("ADM") || user_Role.includes("PRM") || user_Role.includes("PRO") || user_Role.includes("MIQ") || user_Role.includes("MDM")) && selectedOption == "false") &&
                <button className="btn thali_btn" onClick={RemoveModal}>
                  Create Inventory
                </button>
                }
                &nbsp; &nbsp;
                <button
                  className={`btn thali_btn ${
                    selectedOption === "true" ? "active" : ""
                  }`}
                  onClick={() => handleButtonChange("true")}
                >
                  Day
                </button>
                &nbsp; &nbsp;
                <button
                  className={`btn thali_btn ${
                    selectedOption === "false" ? "active" : ""
                  }`}
                  onClick={() => handleButtonChange("false")}
                >
                  By Aggregate
                </button>
                &nbsp; &nbsp;
                {selectedOption === "false" ? (
                  <>
                    {/* Content to render when selectedOption is "false" */}
                    <button className="btn thali_btn csvbtn">
                      <CSVLink
                        data={user_Role.includes("OPT") || user_Role.includes("ADM") ? csvData : csvNoCostData}
                        headers={user_Role.includes("OPT") || user_Role.includes("ADM") ? csvHeaders : csvNoCostHeaders}
                        filename={"Combined_Export_Data_By_Aggregate.csv"}
                      >
                        Export Data
                      </CSVLink>
                    </button>
                  </>
                ) : (
                  <button className="btn thali_btn csvbtn">
                    <CSVLink
                      data={user_Role.includes("OPT") || user_Role.includes("ADM") ? csvDataDay : csvNoCostDataDay}
                      headers={user_Role.includes("OPT") || user_Role.includes("ADM") ? csvHeadersDay : csvNoCostHeadersDay}
                      filename={"Combined_Export_Data_By_Day.csv"}
                    >
                      Export Data
                    </CSVLink>
                  </button>
                )}
              </div>

              {/* <button
        className={selectedOption ? 'active' : ''}
        onClick={() => handleOptionClick(true)}
      >
        Day
      </button>
      <button
        className={!selectedOption ? 'active' : ''}
        onClick={() => handleOptionClick(false)}
      >
        By Aggregate
      </button> */}
            </div>
            {/* <div className="row">
              <div className="lebal_pdf_download">
                <h1 className="title_heading ">
                  PDF Download
                </h1>
                <div className="pdf_btn">
                  <button> <img src={ZoneSheets} className='img-fluid' /></button>
                  <button> <img src={LabelSheets} className='img-fluid' /></button>
                  <button> <img src={GrocerySheets} className='img-fluid' /></button>
                </div>
              </div>
            </div> */}
            { standardinventory == "1" &&
            <div>
                  <div>
                      <div >
                        <div style={{ color: 'red', fontSize: 18, textAlign: "center", fontStyle: "italic" }}>NOTE: Standard Ingredients are added.</div>
                        <div style={{ color: 'red', fontSize: 18, textAlign: "center", fontStyle: "italic" }}>Disable "Add Standard Ingredients" to remove them.</div>
                      </div>
                  </div>
            </div>
            }
            <div className="ExportInventory_calender">
              <div className="row">
                <div className="col-lg-3 col-md-2">
                  <div className="Week_list hover_remove">
                    <div className="week_img">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="28"
                        viewBox="0 0 24 28"
                        fill="none"
                      >
                        <path
                          d="M6.33333 15.9998C6.04444 15.9998 5.80556 15.9054 5.61667 15.7165C5.42778 15.5276 5.33333 15.2887 5.33333 14.9998C5.33333 14.7109 5.42778 14.4721 5.61667 14.2832C5.80556 14.0943 6.04444 13.9998 6.33333 13.9998H17.6667C17.9556 13.9998 18.1944 14.0943 18.3833 14.2832C18.5722 14.4721 18.6667 14.7109 18.6667 14.9998C18.6667 15.2887 18.5722 15.5276 18.3833 15.7165C18.1944 15.9054 17.9556 15.9998 17.6667 15.9998H6.33333ZM6.33333 21.9998C6.04444 21.9998 5.80556 21.9054 5.61667 21.7165C5.42778 21.5276 5.33333 21.2887 5.33333 20.9998C5.33333 20.7109 5.42778 20.4721 5.61667 20.2832C5.80556 20.0943 6.04444 19.9998 6.33333 19.9998H13.6333C13.9222 19.9998 14.1611 20.0943 14.35 20.2832C14.5389 20.4721 14.6333 20.7109 14.6333 20.9998C14.6333 21.2887 14.5389 21.5276 14.35 21.7165C14.1611 21.9054 13.9222 21.9998 13.6333 21.9998H6.33333ZM2 27.3332C1.46667 27.3332 1 27.1332 0.6 26.7332C0.2 26.3332 0 25.8665 0 25.3332V4.6665C0 4.13317 0.2 3.6665 0.6 3.2665C1 2.8665 1.46667 2.6665 2 2.6665H4.16667V1.73317C4.16667 1.44428 4.27222 1.19428 4.48333 0.983171C4.69444 0.772059 4.95556 0.666504 5.26667 0.666504C5.55556 0.666504 5.80556 0.772059 6.01667 0.983171C6.22778 1.19428 6.33333 1.44428 6.33333 1.73317V2.6665H17.6667V1.73317C17.6667 1.44428 17.7722 1.19428 17.9833 0.983171C18.1944 0.772059 18.4556 0.666504 18.7667 0.666504C19.0556 0.666504 19.3056 0.772059 19.5167 0.983171C19.7278 1.19428 19.8333 1.44428 19.8333 1.73317V2.6665H22C22.5333 2.6665 23 2.8665 23.4 3.2665C23.8 3.6665 24 4.13317 24 4.6665V25.3332C24 25.8665 23.8 26.3332 23.4 26.7332C23 27.1332 22.5333 27.3332 22 27.3332H2ZM2 25.3332H22V10.9998H2V25.3332Z"
                          fill="#957137"
                        />
                      </svg>
                    </div>

                    {Statedate ? (
                      <div className="week_text">
                        <h4>DATE RANGE</h4>
                        <h1>
                          {formatDate(rangeStartDate)}-
                          {formatDate(rangeEndDate)}
                        </h1>
                      </div>
                    ) : (
                      <div className="week_text">
                        <h4>By Aggregate</h4>
                        <h1>
                          {formatDate(IngredientStatedate)}-
                          {formatDate(IngredientEnddate)}
                        </h1>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-3 col-md-2">
                    <div className="Week_list INGREDIENTS_Cout hover_remove">
                      <div className="week_img">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="26"
                          viewBox="0 0 20 26"
                          fill="none"
                        >
                          <path
                            d="M19.5998 10.8148V16.122H0.399902V10.8148H19.5998ZM0.399902 17.3709H19.5998V22.6782L0.399902 22.6784V17.3709ZM3.4768 1.44887C3.4768 0.762038 4.03054 0.200195 4.70745 0.200195H15.292C15.9689 0.200195 16.5227 0.762038 16.5227 1.44887V6.44413H14.6764L14.6768 3.32194C14.6768 2.97851 14.4 2.6976 14.0615 2.6976H5.93837C5.5999 2.6976 5.32304 2.97853 5.32304 3.32194V6.4439H3.47679L3.4768 1.44887ZM13.446 6.4439H6.55354V3.94627H13.4458L13.446 6.4439ZM2.86142 7.6928H17.1383C18.2767 7.6928 19.2305 8.50445 19.5075 9.56609L0.492264 9.56587C0.76935 8.50446 1.72303 7.6928 2.86142 7.6928ZM18.369 25.8002H1.63066C0.953745 25.8002 0.400013 25.2384 0.400013 24.5515V23.9272H19.5999V24.5515C19.5999 25.2381 19.0459 25.8002 18.369 25.8002Z"
                            fill="#591333"
                          />
                        </svg>
                      </div>
                      <div className="week_text">
                        <h4>Total Full Thaali Count </h4>
                        <h1>
                          {totalselectedFullThaaliCount ? totalselectedFullThaaliCount : "-"}
                        </h1>
                      </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-2">
                    <div className="Week_list INGREDIENTS_Cout hover_remove">
                      <div className="week_img">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="26"
                          viewBox="0 0 20 26"
                          fill="none"
                        >
                          <path
                            d="M19.5998 10.8148V16.122H0.399902V10.8148H19.5998ZM0.399902 17.3709H19.5998V22.6782L0.399902 22.6784V17.3709ZM3.4768 1.44887C3.4768 0.762038 4.03054 0.200195 4.70745 0.200195H15.292C15.9689 0.200195 16.5227 0.762038 16.5227 1.44887V6.44413H14.6764L14.6768 3.32194C14.6768 2.97851 14.4 2.6976 14.0615 2.6976H5.93837C5.5999 2.6976 5.32304 2.97853 5.32304 3.32194V6.4439H3.47679L3.4768 1.44887ZM13.446 6.4439H6.55354V3.94627H13.4458L13.446 6.4439ZM2.86142 7.6928H17.1383C18.2767 7.6928 19.2305 8.50445 19.5075 9.56609L0.492264 9.56587C0.76935 8.50446 1.72303 7.6928 2.86142 7.6928ZM18.369 25.8002H1.63066C0.953745 25.8002 0.400013 25.2384 0.400013 24.5515V23.9272H19.5999V24.5515C19.5999 25.2381 19.0459 25.8002 18.369 25.8002Z"
                            fill="#591333"
                          />
                        </svg>
                      </div>
                      <div className="week_text">
                        <h4>Total Miqaat Thaal Count </h4>
                        <h1>
                          {totalselectedMiqaatThaalCount ? totalselectedMiqaatThaalCount : "-"}
                        </h1>
                      </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-2">
                    <div className="Week_list Thali_Count  my-0 my-md-3 my-lg-0 hover_remove">
                      <div className="week_img">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="28"
                          viewBox="0 0 28 28"
                          fill="none"
                        >
                          <path
                            d="M10.8998 19.3332C11.5887 19.3332 12.1665 19.0943 12.6332 18.6165C13.0998 18.1387 13.3332 17.5665 13.3332 16.8998C13.3332 16.2332 13.0998 15.6609 12.6332 15.1832C12.1665 14.7054 11.5998 14.4665 10.9332 14.4665C10.2443 14.4665 9.66095 14.7054 9.18317 15.1832C8.70539 15.6609 8.4665 16.2332 8.4665 16.8998C8.4665 17.5665 8.70539 18.1387 9.18317 18.6165C9.66095 19.0943 10.2332 19.3332 10.8998 19.3332ZM17.0998 19.3332C17.7665 19.3332 18.3387 19.0943 18.8165 18.6165C19.2943 18.1387 19.5332 17.5665 19.5332 16.8998C19.5332 16.2332 19.2943 15.6609 18.8165 15.1832C18.3387 14.7054 17.7665 14.4665 17.0998 14.4665C16.4332 14.4665 15.8609 14.7054 15.3832 15.1832C14.9054 15.6609 14.6665 16.2332 14.6665 16.8998C14.6665 17.5665 14.9054 18.1387 15.3832 18.6165C15.8609 19.0943 16.4332 19.3332 17.0998 19.3332ZM13.9998 13.0998C14.6665 13.0998 15.2387 12.8665 15.7165 12.3998C16.1943 11.9332 16.4332 11.3554 16.4332 10.6665C16.4332 9.99984 16.1943 9.42762 15.7165 8.94984C15.2387 8.47206 14.6665 8.23317 13.9998 8.23317C13.3332 8.23317 12.7609 8.47206 12.2832 8.94984C11.8054 9.42762 11.5665 9.99984 11.5665 10.6665C11.5665 11.3554 11.8054 11.9332 12.2832 12.3998C12.7609 12.8665 13.3332 13.0998 13.9998 13.0998ZM13.9998 27.3332C12.1776 27.3332 10.4554 26.9832 8.83317 26.2832C7.21095 25.5832 5.79428 24.6276 4.58317 23.4165C3.37206 22.2054 2.4165 20.7887 1.7165 19.1665C1.0165 17.5443 0.666504 15.8109 0.666504 13.9665C0.666504 12.1443 1.0165 10.4221 1.7165 8.79984C2.4165 7.17762 3.37206 5.7665 4.58317 4.5665C5.79428 3.3665 7.21095 2.4165 8.83317 1.7165C10.4554 1.0165 12.1887 0.666504 14.0332 0.666504C15.8554 0.666504 17.5776 1.0165 19.1998 1.7165C20.8221 2.4165 22.2332 3.3665 23.4332 4.5665C24.6332 5.7665 25.5832 7.17762 26.2832 8.79984C26.9832 10.4221 27.3332 12.1554 27.3332 13.9998C27.3332 15.8221 26.9832 17.5443 26.2832 19.1665C25.5832 20.7887 24.6332 22.2054 23.4332 23.4165C22.2332 24.6276 20.8221 25.5832 19.1998 26.2832C17.5776 26.9832 15.8443 27.3332 13.9998 27.3332Z"
                            fill="#1F2F32"
                          />
                        </svg>
                      </div>
                      <div className="week_text">
                        <h4>Total Ingredients</h4>
                        <h1>{totalInventory ? totalInventory : "-"}</h1>
                      </div>
                    </div>
                </div>
              </div>

              <div className="thali_procurement_table_section mt-5">
                {loading ? (
                  // Render a loading indicator while data is being fetched
                  <div className="Loading-img">
                    <img src={loadergif} className="" />
                  </div>
                ) : (
                  <div></div>
                )}
                {selectedOption == "true" ? (
                <div className="table table-bordered" id="inventory_day_div">
                <table className="table table-bordered" id="inventory_day">
                  <thead className="thead-dark">
                    <tr>
                        <th scope="col">
                          <span className="thali_table">Day</span>
                        </th>
                      <th scope="col">
                        <span className="thali_table">Menu</span>
                      </th>
                      <th scope="col">
                        <span className="thali_table">Ingredient Name</span>
                      </th>
                      <th scope="col">
                        <span className="thali_table">QTY (Actual)</span>
                      </th>
                      <th scope="col">
                        <span className="thali_table">QTY (100 Thaalis/10 Thaals)</span>
                      </th>
                      <th scope="col">
                        <span className="thali_table">Unit</span>
                      </th>
                      <th scope="col">
                        <span className="thali_table">Vendor</span>
                      </th>
                      <th scope="col">
                        <span className="thali_table">PKG Size</span>
                      </th>
                      {
                       (user_Role.includes("ADM") || user_Role.includes("OPT")) && 
                       <th scope="col">
                          <span className="thali_table">Ingredient cost</span>
                       </th>
                      }
                      <th scope="col">
                        <span className="thali_table">Notes</span>
                      </th>
                    </tr>
                  </thead>
                  {getCurrentPageItems() &&
                    getCurrentPageItems().map((items, index) => {
                      const formattedDate = formatDate(items?.schedule_day, "true")
                      return (
                        <tbody key={items.id}>
                          <tr>
                              <th scope="row">
                                <ul className="thali_menu_list">
                                  <li>
                                    {formattedDate}
                                  </li>
                                </ul>
                              </th>
                            <th scope="row">
                              <ul className="thali_menu_list">
                                <li>{items.dish_name}</li>
                              </ul>
                            </th>
                            <th scope="row">
                              <ul className="thali_menu_list">
                                <li>{items.ingredient_name}</li>
                              </ul>
                            </th>
                            <th scope="row">
                              <ul className="thali_menu_list">
                                <li>
                                  {" "}
                                  {items.total_quantity && items.total_quantity != 9898
                                    ? items?.total_quantity?.toFixed(2)
                                    : ""}
                                </li>
                              </ul>
                            </th>
                            <th scope="row">
                              <ul className="thali_menu_list">
                                <li>
                                  {" "}
                                  {items.menu_quantity && items.total_quantity != 9898
                                    ? items.menu_quantity
                                    : ""}
                                </li>
                              </ul>
                            </th>
                            <th scope="row">
                              <ul className="thali_menu_list">
                                <li> {items.package_unit}</li>
                              </ul>
                            </th>
                            <th scope="row">
                              <ul className="thali_menu_list">
                                <li> {items.vendor_name1}</li>
                              </ul>
                            </th>
                            <th scope="row">
                              <ul className="thali_menu_list">
                                <li>
                                  {" "}
                                  {items?.package_size !== "NULL"
                                    ? items.package_size
                                    : "-"}
                                </li>
                              </ul>
                            </th>
                            {
                            (user_Role.includes("ADM") || user_Role.includes("OPT")) && 
                            <th scope="row">
                              <ul className="thali_menu_list">
                                <li>
                                  {items?.ingredient_cost
                                    ? "$ "+ items.ingredient_cost?.toFixed(2)
                                    : "-"}
                                </li>
                                <li>
                                    {/* Ingredient Cost Display */}
                                    <span
                                      style={{
                                        color: isOlderThanSixMonths(items.cost_updated_at) ? "#993530" : "inherit",
                                      }}
                                    >
                                      {items.ingredient_cost || "-"}
                                    </span>
  
                                    {/* Info Icon (Visible for all items with a price) */}
                                    {items.ingredient_cost && (
                                      <>
                                        <img
                                          src={warningLogo}
                                          style={{
                                            marginLeft: "8px",
                                            cursor: "pointer",
                                            width: "16px",
                                            height: "16px",
                                            filter: isOlderThanSixMonths(items.cost_updated_at)
                                              ? "none" // Red color
                                              : "invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)", // Black color
                                          }}
                                          onMouseEnter={() => setIsTooltipVisible(index)}
                                          onMouseLeave={() => setIsTooltipVisible(null)}
                                          onClick={() => setIsTooltipVisible(isTooltipVisible === index ? null : index)}
                                        />
  
                                        {/* Custom Tooltip */}
                                        {isTooltipVisible === index && (
                                          <div
                                            style={{
                                              position: "absolute",
                                              top: "50%",
                                              left: "10px",
                                              backgroundColor: "#333",
                                              color: "#fff",
                                              padding: "6px 10px",
                                              borderRadius: "5px",
                                              fontSize: "12px",
                                              zIndex: 1000,
                                              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Last updated on: {new Date(items.cost_updated_at).toLocaleDateString()}
                                          </div>
                                        )}
                                      </>
                                    )}
                                </li>
                              </ul>
                            </th>
                            }
                            <th scope="row">
                              <ul className="thali_menu_list">
                                <li>
                                  {" "}
                                  {items?.ingredient_note !== "NULL"
                                    ? items.ingredient_note
                                    : "-"}
                                </li>
                              </ul>
                            </th>
                          </tr>
                        </tbody>
                      );
                    })}
                </table>
                </div>
                ):(
                <div className="table table-bordered" id="inventory_aggregate_div">
                <table className="table table-bordered" id="inventory_aggregate">
                  <thead className="thead-dark">
                    <tr>
                      <th
                        scope="col"
                        // onClick={() => handleSort("ingredient_name")}
                      >
                        <span className="thali_table">
                          Ingredient Name &nbsp; &nbsp;{" "}
                          {/* {getSortIcon("ingredient_name")} */}
                        </span>
                      </th>
                      <th scope="col">
                        <span className="thali_table">QTY (Actual)</span>
                      </th>
                      <th scope="col">
                        <span className="thali_table">QTY (100 Thaalis/10 Thaals)</span>
                      </th>
                      <th scope="col">
                        <span className="thali_table">Unit</span>
                      </th>
                      <th scope="col">
                        <span className="thali_table">Vendor</span>
                      </th>
                      <th scope="col">
                        <span className="thali_table">PKG Size</span>
                      </th>
                      {
                      (user_Role.includes("ADM") || user_Role.includes("OPT")) && 
                      <th scope="col">
                        <span className="thali_table">Ingredient cost</span>
                      </th>
                      }
                      <th scope="col">
                        <span className="thali_table">Notes</span>
                      </th>
                    </tr>
                  </thead>
                  {getCurrentPageItems() &&
                    getCurrentPageItems().map((items, index) => {
                      const formattedDate = formatDate(items?.schedule_day, "true")
                      return (
                        <tbody key={items.id}>
                          <tr>
                            <th scope="row">
                              <ul className="thali_menu_list">
                                <li>{items.ingredient_name}</li>
                              </ul>
                            </th>
                            <th scope="row">
                              <ul className="thali_menu_list">
                                <li>
                                  {" "}
                                  {items.total_quantity && items.total_quantity != 9898
                                    ? items?.total_quantity?.toFixed(2)
                                    : "-"}
                                </li>
                              </ul>
                            </th>
                            <th scope="row">
                              <ul className="thali_menu_list">
                                <li>
                                  {" "}
                                  {items.menu_quantity && items.menu_quantity != 9898
                                    ? items.menu_quantity
                                    : "-"}
                                </li>
                              </ul>
                            </th>
                            <th scope="row">
                              <ul className="thali_menu_list">
                                <li> {items.package_unit}</li>
                              </ul>
                            </th>
                            <th scope="row">
                              <ul className="thali_menu_list">
                                <li> {items.vendor_name1}</li>
                              </ul>
                            </th>
                            <th scope="row">
                              <ul className="thali_menu_list">
                                <li>
                                  {" "}
                                  {items?.package_size !== "NULL"
                                    ? items.package_size
                                    : "-"}
                                </li>
                              </ul>
                            </th>
                            {
                              (user_Role.includes("ADM") || user_Role.includes("OPT")) && 
                              <th scope="row">
                              <ul className="thali_menu_list">
                                {/* <li>
                                {items?.ingredient_cost
                                    ? "$ "+ items.ingredient_cost?.toFixed(2)
                                    : "-"}
                                </li> */}
                                                                <li>
                                    {/* Ingredient Cost Display */}
                                    <span
                                      style={{
                                        color: isOlderThanSixMonths(items.cost_updated_at) ? "#993530" : "inherit",
                                      }}
                                    >
                                  {items?.ingredient_cost
                                      ? "$ "+ items.ingredient_cost?.toFixed(2)
                                      : "-"}                                    </span>
  
                                    {/* Info Icon (Visible for all items with a price) */}
                                    {items.ingredient_cost && isOlderThanSixMonths(items.cost_updated_at) && (
                                      <>
                                        <img
                                          src={warningLogo}
                                          style={{
                                            marginLeft: "8px",
                                            cursor: "pointer",
                                            width: "16px",
                                            height: "16px",
                                            filter: isOlderThanSixMonths(items.cost_updated_at)
                                              ? "none" // Red color
                                              : "invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)", // Black color
                                          }}
                                          // onMouseEnter={() => setIsTooltipVisible(index)}
                                          // onMouseLeave={() => setIsTooltipVisible(null)}
                                          onClick={() => setIsTooltipVisible(isTooltipVisible === index ? null : index)}
                                        />
  
                                        {/* Custom Tooltip */}
                                        {isTooltipVisible === index && (
                                          <div
                                            style={{
                                              position: "absolute",
                                              right: "580px",
                                              backgroundColor: "#333",
                                              color: "#fff",
                                              padding: "6px 10px",
                                              borderRadius: "5px",
                                              fontSize: "12px",
                                              zIndex: 1000,
                                              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Last updated on: {new Date(items.cost_updated_at).toLocaleDateString()}
                                          </div>
                                        )}
                                      </>
                                    )}
                                </li>
                              </ul>
                            </th>
                            }
                            <th scope="row">
                              <ul className="thali_menu_list">
                                <li>
                                  {" "}
                                  {items?.ingredient_note !== "NULL"
                                    ? items.ingredient_note
                                    : "-"}
                                </li>
                              </ul>
                            </th>
                          </tr>
                        </tbody>
                      );
                    })}
                </table>
                </div>
                )}
              </div>
              <div className="thili_div">
                <div className="Back-page">
                  {" "}
                  {/* <h1 className="title_Allow">
                    {" "}
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckChecked"
                        checked
                      />
                    </div>
                    Allow Exporting
                  </h1> */}
                </div>
                {/* <div className="Back-page">
                  <button className="btn thali_btn">Cancel</button>&nbsp; &nbsp;
                  &nbsp;{" "}
                

                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div />
      <Modal
        isOpen={RemoveIsOpen}
        onAfterOpen={RemoveOpenModal}
        onRequestClose={RemovecloseModal}
        style={customStyles}
        contentLabel="Remove Modal"
        id="edit_inventory"
      >
        <div className="popup_modal exp_in">
          <div className="Remove_from">
            {/* <img src={fmblogo} className="img-firud inv-img" /> */}
            <div style={{ color: 'red', fontSize: 30, textAlign: "center" }}>Warning!</div>
            &nbsp;            
            <h5>
              There is already a "Pending" Inventory. {" "}
            </h5>
            <h5>
              Do you still want to create? {" "}
            </h5>
            <div className="Thali_page_btn_from">
              <button onClick={RemovecloseModal} className="btn thali_btn">
                NO
              </button>{" "}
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;

              <button onClick={Createinventory} className="btn thali_btn">
                YES
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
